export default __webpack_public_path__ + "static/media/OceanEyes_tmb.b19286da.jpg";